import { render, staticRenderFns } from "./ComplaintUserCard.vue?vue&type=template&id=fc271ba8"
import script from "./ComplaintUserCard.vue?vue&type=script&lang=ts"
export * from "./ComplaintUserCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports